import {Headers, Sort, SortKeys, SortOrder} from '../types'
import {WPItem, WpTypes} from '../../../../../app/@types'
import {THead} from '../components/THead'
import React, {FC, useMemo, useState} from 'react'
import {KTSVG} from '../../../../helpers'
import {FormatDateToCA} from '../../../../../app/features'


type Props = {
    data: WPItem[],
    showType: boolean
}

const TablesWidget25: FC<Props> = ({data, showType}) => {

    const [sortKey, setSortKey] = useState<SortKeys<WPItem>>('created_at')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')

    const dataSorted: WPItem[] = useMemo(() => {
        return Sort<WPItem>({data, sortKey, reverse: sortOrder === 'desc'})
    }, [data, sortKey, sortOrder])

    // const headers: Headers<WPItem>[] = [
    //     {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light w-lg-125px'},
    //     {key: 'name', label: 'Nom', className: 'fw-bolder text-muted bg-light w-lg-275px'},
    // ]

    const headers = useMemo(() => {
        const baseHeaders: Headers<WPItem>[] = [
            {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light w-lg-125px'},
            {key: 'name', label: 'Nom', className: 'fw-bolder text-muted bg-light w-lg-275px'},
        ]

        if (showType) {
            baseHeaders.push({key: 'type', label: 'Type', className: 'fw-bolder text-muted bg-light w-lg-50px'})
        }

        return baseHeaders
    }, [showType])
    const typeColors: Record<WpTypes, string> = {
        wp: 'primary',
        theme: 'orange',
        plugin: 'info',
    };

    return (
        <>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                           children={<th className="fw-bolder text-muted text-center bg-light w-lg-200px">
                    <span className="btn btn-sm text-muted w-auto px-0 cursor-default">
                      Versions
                    </span>
                           </th>}
                    />

                    <tbody>
                    {
                        dataSorted.map((item, index) => (
                            <tr key={index}>
                                <td className="p-0">
                                    <span
                                        className="text-dark fw-bolder fs-7 pe-4 d-flex justify-content-center align-items-center">{FormatDateToCA(item.created_at, true)}</span>
                                </td>
                                <td>
                                    <div className="d-flex flex-column w-100 me-2">
                                        <span className="text-muted me-2 fs-7 fw-bold">{item.name}</span>
                                    </div>
                                </td>
                                {
                                    showType && <td>
                                    <span className={`badge badge-light-${typeColors[item.type]} fw-bold fs-8 text-start`}>{item.type}</span>
                                  </td>
                                }
                                <td className="text-center">
                                    <div className="">
                                        <span
                                            className="badge badge-light-danger fw-bold fs-8 text-start">{item.oldVersion}</span>
                                        <KTSVG path={`/media/icons/duotune/arrows/arr064.svg`}
                                               className="svg-icon-4 svg-icon-primary mx-0" />
                                        <span
                                            className="badge badge-light-success fw-bold fs-8 text-end">{item.newVersion}</span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>

                </table>
            </div>
        </>
    )
}

export {TablesWidget25}